module.exports = __webpack_public_path__ + "static/img/America.5a6bfcf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/America.svg
// module id = E4cJ
// module chunks = 44